import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { FicheCandidatAction } from '../components/candidat/FicheCandidatAction';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CandidatActionPage() {
  const { dossierId, candidatId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [assiduite, setAssiduite] = useState(null);
  const [error, setError] = useState(null);

  const load = () => Promise.all([
    axios.get(`${API_URL}/portail/formateur/action/${dossierId}`),
    axios.get(`${API_URL}/portail/formateur/action/${dossierId}/assiduite`).catch(() => ({ data: null })),
  ]).then(([a, s]) => { setData(a.data); setAssiduite(s.data); })
    .catch(e => { setError(e.response?.data?.detail || 'Erreur lors du chargement'); toast.error(e.response?.data?.detail || 'Erreur lors du chargement'); });

  useEffect(() => { load(); }, [dossierId, candidatId]); // eslint-disable-line react-hooks/exhaustive-deps

  const candidat = data?.candidats?.find(c => c.id === candidatId);

  return (
    <DashboardLayout>
      {error ? (
        <p className="p-6 text-sm text-red-600" data-testid="candidat-action-error">{error}</p>
      ) : !data ? (
        <div className="flex items-center justify-center h-64"><Loader2 className="w-8 h-8 animate-spin text-indigo-600" /></div>
      ) : !candidat ? (
        <p className="p-6 text-sm text-slate-500" data-testid="candidat-action-notfound">Ce candidat n'est pas affecté à cette action de formation.</p>
      ) : (
        <div className="space-y-0">
          <p className="max-w-7xl mx-auto px-6 pt-4 text-xs text-slate-500"><span className="font-mono text-slate-400">{data.dossier.code}</span> — {data.dossier.intitule}</p>
          <FicheCandidatAction
            dossier={data.dossier}
            candidat={candidat}
            assiduite={assiduite}
            onBack={() => (new URLSearchParams(window.location.search).get('from') === 'apercu' ? navigate(`/dossiers/${dossierId}?section=candidats`) : navigate(-1))}
            onCandidatUpdated={load}
            onAbandonChanged={load}
          />
        </div>
      )}
    </DashboardLayout>
  );
}
